<div class="grid-container" *ngIf="!loading">
  <div class="esf-accordion esf-accordion--info-tiles">
    <div app-accordion-table
         class="esf-accordion__unit esf-accordion--info-tiles"
         [accordionHeading]="tablesTranslations.i18nMembershipCampai"
         [isPanelOpened]="isPanelOpened"
         [actionButtonTooltip]="tooltipTranslations.i18nCreateNewMembership"
         [emptyStateIcon]="'#esf-icon-users'"
         [emptyStateText]="tablesTranslations.i18nNoMembership"
         [emptyStateButtonText]="disableSubmit ? '' : tablesTranslations.i18nTransferToCampai"

         (actionButtonClickEvent)="transferMembershipModal()"
         (rowClickEvent)="editMembership($event)"
         (rowButtonClickEvent)="deleteMembershipModal($event)"
         (panelTriggerClickEvent)="isPanelOpenedChange.emit(!isPanelOpened)"

         [data]="currentMembership"
         [keys]="keys"
         [columns]="columns">
    </div>
  </div>
</div>

<app-local-modal [title]="modalTitle"
                 *ngIf="!loading"
                 [submitDisabled]="!customer.hasTixxId"
                 (submitClicked)="createMembership()">
  <p i18n="@@modal.paragraph.transferToCampai">
    This option will transfer the choosen customer as a new member to campai and initiate the customer data synchronisation. Would you like to proceed?
  </p>
  <button class="esf-button esf-button--simple"
          [disabled]="!customer.hasTixxId"
          (click)="copyCampaiID()">
    <svg class="esf-icon esf-button__icon" width="16" height="16">
      <use xlink:href="#esf-icon-copy"></use>
    </svg>
    <span class="esf-button__icon-text" i18n="@@general.button.copyCampaiId">Copy Campai ID</span>
  </button>
</app-local-modal>
